export const RemoveEmptyFiledFromObject = <T extends object>(obj: T) => {
  Object.keys(obj).forEach(
    key =>
      (obj[key as keyof T] === undefined || obj[key as keyof T] === '') &&
      delete obj[key as keyof T],
  );
};
